import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeContext = createContext({ me: undefined, refresh: () => {} });

// The signed-in person's role and project limit (undefined while loading, null if unavailable).
export const MeProvider = ({ children }) => {
  const { isSignedIn, userId } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(undefined);

  const refresh = useCallback(() => {
    if (!isSignedIn) return setMe(null);
    api.get("/me").then(setMe).catch(() => setMe(null));
  }, [api, isSignedIn]);

  useEffect(() => { refresh(); }, [refresh, userId]);

  return <MeContext.Provider value={{ me, refresh }}>{children}</MeContext.Provider>;
};

export const useMe = () => useContext(MeContext);
